// Page title, description, Open Graph tags and JSON-LD structured data for search engines.
// Set through the DOM (no inline <script> in index.html): a JSON-LD block is data, never executed.
const MANAGED = "data-hs-seo";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"][${MANAGED}]`) || document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute(MANAGED, "1");
  el.setAttribute("content", content);
}

export function setSeo({ title, description, url, jsonLd }) {
  if (title) { document.title = title; setMeta("property", "og:title", title); setMeta("name", "twitter:title", title); }
  if (description) { setMeta("name", "description", description); setMeta("property", "og:description", description); setMeta("name", "twitter:description", description); }
  if (url) {
    setMeta("property", "og:url", url);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
    link.setAttribute("href", url);
  }
  let ld = document.head.querySelector(`script[type="application/ld+json"][${MANAGED}]`);
  if (jsonLd) {
    if (!ld) { ld = document.createElement("script"); ld.setAttribute("type", "application/ld+json"); ld.setAttribute(MANAGED, "1"); document.head.appendChild(ld); }
    ld.textContent = JSON.stringify(jsonLd).replace(/</g, "\\u003c");
  } else if (ld) {
    ld.remove();
  }
}
